import type { ScrollSnapSlider } from 'scroll-snap-slider';

export default function getSlideIndex({ event, slider }: { event: CustomEvent; slider: ScrollSnapSlider }) {
    const slideElementIndex = event.detail;
    const slideElement = slider.element.children[slideElementIndex] as HTMLElement;

    return Number(slideElement.dataset.slideIndex);
}
